import { Component, OnInit, Input } from '@angular/core';
// import { SettingsService } from '../../../core/settings/settings.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import { SettingsService } from '../core/settings/settings.service';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LoginModel } from './login.model';
import { MenuService } from '../core/menu/menu.service';
import { menu } from '../core/menu/menu';
import { BaseModel } from '@ngx-resource-toolkit/core';
import { ToasterService } from 'angular2-toaster';
import { ReferenceObjectModel } from '../shared/reference/models/reference-object.model';
import { DisponibiliteComponent } from '../shared/disponibilite/disponibilite.component';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    valForm: FormGroup;
    loginError: string;
		@Input() anneesScolaires: any[];

    constructor(public http: HttpClient, public router: Router, public menu: MenuService, public settings: SettingsService,
        private toaster: ToasterService,
        fb: FormBuilder) {
					this.valForm = fb.group({
							'username': [null, Validators.required],
							'password': [null, Validators.required],
							'anneeScolaire': [null, Validators.required],
					});
            this.initAnneesScolaires();
    }

    initAnneesScolaires() {
        // Récupération de la liste des années
        console.log('Recherche des années scolaires');
        const model = new ReferenceObjectModel();
        model.getResource('default', 'get')
            .call(this.http, 'getReferenceObjects', ['ref_annee_scolaire'])
            .subscribe(
                (data) => {
                    this.anneesScolaires = [];
                    if (data.success === false) {
                        // success = false certainement à cause du token présent qui a expiré => on l'enlève et on recommence
                        // console.log('data.success=false', this.settings.getUserSetting('token'));
                        this.settings.removeUserSetting();
                        // this.initAnneesScolaires();
                    } else {
                        if (data instanceof Array) {
                            data.forEach((annee) => {
                                // console.log('année :', annee);
                                if (annee.default === true) {
                                    this.valForm.controls['anneeScolaire'].setValue(annee);
                                    localStorage.setItem('defaultYear', annee.id);
                                }
                                this.anneesScolaires.push(annee);
                            });
                          }
                    }
                  }, (err) => {
                      console.log('AnneeScolaire', 'search error', err);
                      this.toaster.pop('error', 'Erreur lors de la recherche des années scolaires :  le service n\'est pas DisponibiliteComponent.');
                  });

        // Récupération de l'année par défaut

    }

    get anneeScolaire(): string {
        console.log(this.valForm);
        return this.valForm ? this.valForm.get('anneeScolaire').value : '';
    }
    submitForm($ev, value: any) {
        $ev.preventDefault();
        for (const c in this.valForm.controls) {
            this.valForm.controls[c].markAsTouched();
        }
        if (this.valForm.valid) {

            const model = new LoginModel(this.valForm.value);
            const {username, password} = this.valForm.value;
            // remplacement de la version et env en dur par navigateur utilisé
            // const params = [username, password, '1.0.0', 'dev'];
            const params = [username, password, navigator.appName, navigator.userAgent];
            model.getResource('default', 'post').call(this.http, 'login', null, params).subscribe((data) => {
                console.log('login success', data);

                if (data.success) {
                    delete data.user.password;
                    this.settings.setUserSetting({
                        ...data.user,
                        // password: '',
                        anneeScolaire: this.valForm.value['anneeScolaire'].id,
                        anneeScolaireLibelle: this.valForm.value['anneeScolaire'].libelle,
                        token: data.token,
                    });
                    this.menu.init(menu);
                    const isRouteFamilleAllowed = this.settings.isUserRouteAllowed('/famille');
                    this.router.navigate([isRouteFamilleAllowed ? 'famille' : 'eleve']); // on l'envoie sur famille et il sera redirigé sur l'adresse par défaut s'il n'a pas les droits
                } else {
                    this.loginError = data.message;
                }


            }, (err) => console.log('Login error', err));


        }
    }

    ngOnInit() {
        /*this.searchModel.registerEntryDynamicProperty(['search'], 'anneeScolaire', 'default'
        , this.settings.getUserSetting('anneeScolaire'));
*/

    }

}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/login/login.component.ts